import React from 'react';
import StockModule from './StockModule';
import HamsterFloatingButton from './HamsterFloatingButton';
import Layout from './Layout';
import './StockDashboard.css';

const StockDashboard = () => {
    return (
        <Layout showLeftNavSidebar={true} showRightSidebar={false}>
            <div className="stock-main-content">
                <StockModule />
                <HamsterFloatingButton />
            </div>
        </Layout>
    );
};

export default StockDashboard; 